import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { DropdownToggleWrapper } from './DropdownToggle.elements'

// Context
import { useDropdown } from '../DropdownContext'

function DropdownToggle(props) {
  // Destructure
  const { children, caret, color } = props

  // Context
  const { toggle } = useDropdown()

  return (
    <DropdownToggleWrapper onClick={toggle} caret={caret} color={color}>
      {children}
    </DropdownToggleWrapper>
  )
}

// Default Props
DropdownToggle.defaultProps = {
  caret: false,
  color: '',
  children: '',
}

// Proptypes Validation
DropdownToggle.propTypes = {
  caret: PropTypes.bool,
  color: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
}

export default DropdownToggle
